import React from 'react';
import {generatePath, useHistory, useRouteMatch} from 'react-router-dom';
import {makeStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import {Link} from "react-router-dom";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import clsx from 'clsx';
import EcoIcon from '@material-ui/icons/Eco';
import NewReleasesIcon from '@material-ui/icons/NewReleases';
import Button from '@material-ui/core/Button';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Swal from 'sweetalert2'


const useStyles = makeStyles((theme) => ({
    orangeBorder: {
        color: " orange"
    },
}));

const useParamsAsState = () => {
    const {path, params} = useRouteMatch()
    const history = useHistory()

    const updateParams = (updatedParams) => {
        Object.assign(params, updatedParams)
        history.push(generatePath(path, params))
    }
    return [params, updateParams]
}

export default function GroupDetail() {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [{labelId, groupId}, updateParams] = useParamsAsState()
    const [label, setLabel] = React.useState();

    if (label === undefined || label?.id != labelId) {
        fetch(process.env.REACT_APP_API_URL + "/group/" + groupId + "/label/" + labelId, {
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("BEARER_TOKEN")
            }
        })
            .then(response => response.json())
            .then((response) => {
                setLabel(response)
            })
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);

    function changeLabelStatus(newStatus) {
        fetch(process.env.REACT_APP_API_URL + "/group/" + groupId + "/label/" + labelId + "/status", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + localStorage.getItem("BEARER_TOKEN")
            },
            redirect: 'follow',
            body: JSON.stringify({label: {status: newStatus}})
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(response.statusText)
                }
                window.location.reload()
            })
    }

    if (label === undefined) return "Caricamento";


    if (label.order.total_paid === "0.00") {
        Swal.fire(
            'Attenzione, ordine inconsistente',
            'Quest\'ordine potrebbe avere delle inconsistenze. Perfavore effettua un doppio controllo anche su Prestashop.',
            'warning'
        )
    }

    return (<>

        <Grid container spacing={3} direction="row" justify="space-evenly" alignItems="center">
            <Grid item xs={1}>
                <Link to={"/group/" + label.group_id}>
                    <Button size="small" className={classes.margin}>
                        <ArrowBackIosIcon style={{fontSize: 15}}/> Indietro
                    </Button>
                </Link>
            </Grid>
            <Grid item xs={10}></Grid>

            <Grid item xs={2}>
                {label.id > label.stats.min && <Link to={"/group/" + groupId + "/label/" + (label.id - 1)}>
                    <IconButton aria-label="delete">
                        <KeyboardArrowLeftIcon/>
                    </IconButton>
                </Link>}
            </Grid>
            <Grid item xs={8} container>
                <Grid item xs={12}>
                    <Typography gutterBottom variant="h4">
                        Foglio {Math.floor((label.id - label.stats.min) / 4) + 1}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography gutterBottom variant="h6" className={clsx(classes.orderBtn, {
                        [classes.orangeBorder]: label.status !== "normale",
                    })}>
                        Etichetta {((label.id - label.stats.min) % 4) + 1}
                    </Typography>
                </Grid>
            </Grid>
            <Grid item xs={2}>
                {label.id < label.stats.max && <Link to={"/group/" + groupId + "/label/" + (label.id + 1)}>
                    <IconButton aria-label="delete">
                        <KeyboardArrowRightIcon/>
                    </IconButton>
                </Link>}
            </Grid>
            <Grid item xs={12} container style={{borderTop: "1px solid black"}} direction="row" justify="space-evenly"
                  alignItems="flex-start">
                <Grid item xs={1}>
                    {label.order.recyclable === 1 && <EcoIcon style={{color: "green"}}/>}
                    {label.order.customer_orders_made === 0 && <NewReleasesIcon style={{color: "gold"}}/>}
                </Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={6}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography gutterBottom variant="h6"
                                        style={{textOverflow: "ellipsis", overflow: "hidden"}}>
                                {label.order.reference}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography gutterBottom>
                                {label.order.fullname}
                            </Typography>
                            {label.order.customer_orders_made &&
                                <span>({label.order.customer_orders_made} ordini effettuati)</span>}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={1}>
                    <IconButton
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        onClick={handleClick}
                    >
                        <MoreVertIcon/>
                    </IconButton>
                    <Menu
                        id="long-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={open}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={() => {
                            let nextStatus = label.status === "normale" ? "standby" : "normale";
                            changeLabelStatus(nextStatus)
                        }}>
                            Metti etichetta in {label.status === "normale" ? "standby" : "normale"}
                        </MenuItem>
                    </Menu>


                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={10}>
                </Grid>

                <List dense>
                    {label.products.reduce(reduceProducts, [[], [], [], [], [], [], [], [], []]).map((category, i) => {
                        if (category.length !== 0)
                            return <div>
                                <p style={{fontWeight: 900, marginBottom: 5}}>
                                                
                                                <span>
                                                    {i === 0 &&
                                                        <span><span style={{padding: 10}}>🇮🇹</span> ITALIANI <span
                                                            style={{padding: 10}}>🇮🇹</span></span>
                                                    }

                                                    {i === 1 &&
                                                        <span><span style={{padding: 10}}>🇯🇵</span> GIAPPONESI <span
                                                            style={{padding: 10}}>🇯🇵</span></span>
                                                    }

                                                    {i === 2 &&
                                                        <span><span style={{padding: 10}}>🗿</span> FIGURES <span
                                                            style={{padding: 10}}>🗿</span></span>
                                                    }

                                                    {i === 3 &&
                                                        <span><span style={{padding: 10}}>🃏</span> CARD GAME <span
                                                            style={{padding: 10}}>🃏</span></span>
                                                    }

                                                    {i === 4 &&
                                                        <span><span style={{padding: 10}}>👾</span> EVENTI <span
                                                            style={{padding: 10}}>👾</span></span>
                                                    }
                                                    {i === 5 &&
                                                        <span>
                                                            <span style={{padding: 10}}>👕</span> ABBIGLIAMENTO <span style={{padding: 10}}>👕</span>
                                                        </span>
                                                    }
                                                    {i === 6 &&
                                                        <span>
                                                            <span style={{padding: 10}}>🛡</span> BUSTINE <span style={{padding: 10}}>🛡</span>
                                                        </span>
                                                    }
                                                    {i === 7 &&
                                                        <span>
                                                            <span style={{padding: 10}}>🕰</span> VINTAGE <span style={{padding: 10}}>🕰</span>
                                                        </span>
                                                    }
                                                    {i === 8 &&
                                                        <span>
                                                            <span style={{padding: 10}}>📦</span> ABBONAMENTI <span style={{padding: 10}}>📦</span>
                                                        </span>
                                                    }
                                                    </span>
                                </p>
                                {
                                    category.sort(sortProduct).map((product, i) => {
                                        return  <a
                                            href={"https://mangayo.it/" + product.product_image_url}
                                            target={"_blank"}
                                            rel="noreferrer"
                                            style={{color: "black", textDecoration: "none"}}
                                        >
                                            <ListItem key={product.product_name + i + label.id} style={{textDecoration: "none"}}>
                                                <ListItemIcon>
                                                    {function () {
                                                        return (product.quantity > 1) ?
                                                            <span style={{
                                                                color: "red",
                                                                fontWeight: 700
                                                            }}>{product.quantity}</span> :
                                                            <span>{product.quantity}</span>
                                                    }()
                                                    }
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={product.product_name}
                                                />
                                        </ListItem>
                                        </a>
                                    })
                                }
                            </div>
                    })}
                </List>
            </Grid>

            <Grid item xs={12} container style={{borderTop: "1px solid black", marginTop: 20}}>
                <Grid item xs={4}>
                    Prodotti: <b>{label.products.filter(p => p.event_product === 0 && !isSubscriptionProduct(p)).reduce((a, c) => a + c.quantity, 0)}</b>
                </Grid>
                <Grid item xs={4}>

                </Grid>
                <Grid item xs={4}>
                    Totale: {label.order.total_paid}€ <br/>
                    {label.order.payment_method && <span>({label.order.payment_method})</span>}
                </Grid>
            </Grid>

        </Grid>
    </>);
}

// Claim orders ("Riscatto prodotti riservati (Spedizione claim: ...)") are not real products:
// they go in their own section and are left out of the product count.
export function isSubscriptionProduct(product) {
    return /claim/i.test(product.product_name ?? "");
}

function reduceProducts(acc, obj) {
    if (isSubscriptionProduct(obj)) {
        acc[8].push(obj);
    } else if (obj.japanese_product ?? 0) {
        acc[1].push(obj);
    } else if (obj.figure_product ?? 0) {
        acc[2].push(obj);
    } else if (obj.card_game_product ?? 0) {
        acc[3].push(obj);
    } else if (obj.event_product ?? 0) {
        acc[4].push(obj);
    } else if (obj.fashion_product ?? 0) {
        acc[5].push(obj);
    } else if (obj.protective_product ?? 0) {
        acc[6].push(obj);
    } else if (obj.vintage_product ?? 0) {
        acc[7].push(obj);
    } else {
        acc[0].push(obj); //Di default tutti italiani
    }

    return acc;
}

function removeAccents(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function sortProduct(a, b) {
    const regex = /[0-9]+/g;

    // Dirty hack: if both are event products, try sorting by image_url number
    if (a.event_product && b.event_product) {
        const aMatch = a.product_image_url.match(regex);
        const bMatch = b.product_image_url.match(regex);

        if (aMatch && bMatch) {
            const aNum = parseInt(aMatch[0]);
            const bNum = parseInt(bMatch[0]);
            return aNum - bNum;
        }
    }

    let aName = removeAccents(a.product_name);
    let bName = removeAccents(b.product_name);

    let bLengh80 = (bName.length * 8) / 10;
    if (aName.includes(bName.substr(0, bLengh80))) {
        try {
            let aNum = aName.match(regex);
            let bNum = bName.match(regex);
            return parseInt(aNum) > parseInt(bNum) ? 1 : -1;
        } catch (error) {
            return aName > bName ? 1 : -1;
        }
    }

    return aName > bName ? 1 : -1;
}
